exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.table tbody tr:hover {\n  background-color: #f5f8fa;\n  cursor: pointer;\n  border: none;\n  transform: none;\n  position: relative;\n  z-index: 2;\n}\n.table tbody tr:hover.disabled {\n    cursor: not-allowed;\n    background-color: #ffffff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5909d73d","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/tools/modal/GenderPricesDependencies.vue
// module id = 1543
// module chunks = 0